import { INPUT_MSG } from "@/consts/message";

interface IProps {
    isPinCheckFailed: boolean;
}

const PinGuideTextArea = ({isPinCheckFailed}: IProps) => {
    return (
        <div className="txt-area">
            <p className="body-s-n fw-b">{isPinCheckFailed ? INPUT_MSG.PIN_CHECK_FAILED : '거래시 보안을 위해 PIN 비밀번호가 필요합니다.'}</p>
        </div>
    )
}

export default PinGuideTextArea;
